import React, { ReactNode } from 'react'

import { MarginProps, MaxWidthProps } from 'styled-system'

import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import {
  PrimaryHeading,
  PrimaryParagraph,
  SecondaryHeading,
} from 'Components/Blocks/Typography'
import { Column } from 'Components/UI'

import { StripedCircleSvg } from 'Assets/Svg'

import { Container } from './styles'

type Props = MarginProps &
  MaxWidthProps & {
    centered?: boolean
    inverse?: boolean
    maxWidth?: number | number[]
    subtitle?: ReactNode
    title: ReactNode
    paragraph?: ReactNode
  }

function SubsectionTitle({
  centered,
  inverse,
  maxWidth,
  subtitle,
  paragraph,
  title,
  ...rest
}: Props) {
  return (
    <Column
      {...rest}
      alignCenter={centered}
      alignStart={!centered}
      fullWidth
      gap={[6, 6, 6, 7]}
      justifyCenter={centered}
      maxWidth={maxWidth}
    >
      <AppearingWrapper centered={centered} kind="expand">
        <Container centered={centered}>
          {StripedCircleSvg()}

          <PrimaryHeading centered={centered} inverse={inverse} text={title} />
        </Container>
      </AppearingWrapper>

      {subtitle && (
        <SecondaryHeading
          centered={centered}
          inverse={inverse}
          text={subtitle}
        />
      )}

      {paragraph && (
        <PrimaryParagraph
          centered={centered}
          inverse={inverse}
          text={paragraph}
        />
      )}
    </Column>
  )
}

export default SubsectionTitle
